document.addEventListener('DOMContentLoaded', function () {
  const flipCards = document.querySelectorAll('.flip-card');

  flipCards.forEach((card) => {
    const frontFlipButton = card.querySelector('.front-flip-button');
    const backFlipButton = card.querySelector('.back-flip-button');
    const back = card.querySelector('.flip-card-back');
    if (!frontFlipButton || !backFlipButton) return;

    if (back) back.setAttribute('aria-hidden', 'true');
    frontFlipButton.setAttribute('aria-expanded', 'false');
    backFlipButton.setAttribute('tabindex', '-1');

    frontFlipButton.addEventListener('click', function () {
      card.classList.add('flipped');
      frontFlipButton.setAttribute('aria-expanded', 'true');
      if (back) back.removeAttribute('aria-hidden');
      backFlipButton.removeAttribute('tabindex');
      frontFlipButton.setAttribute('tabindex', '-1');
      backFlipButton.focus({ preventScroll: true });
    });

    backFlipButton.addEventListener('click', function () {
      card.classList.remove('flipped');
      frontFlipButton.setAttribute('aria-expanded', 'false');
      if (back) back.setAttribute('aria-hidden', 'true');
      backFlipButton.setAttribute('tabindex', '-1');
      frontFlipButton.removeAttribute('tabindex');
      frontFlipButton.focus({ preventScroll: true });
    });
  });
});
